/*
 * @Descripttion: 可拖拽Modal
 * @version: v0.0.1
 * @Author: ZhouYanPing
 * @Date: 2021-06-28 13:54:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-28 14:46:42
 */
import React from 'react'
import { Modal } from 'antd'

class AntDraggableModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.simpleClass = Math.random().toString(36).substring(2);

        this.simpleClass = null;
        this.header = null;
        this.contain = null;
        this.modalContent = null;

        this.mouseDownX = 0;
        this.mouseDownY = 0;
        this.deltaX = 0;
        this.deltaY = 0;
        this.sumX = 0;
        this.sumY = 0;
    }

    handleMove = (event) => {
        const deltaX = event.pageX - this.mouseDownX;
        const deltaY = event.pageY - this.mouseDownY;

        this.deltaX = deltaX;
        this.deltaY = deltaY;

        this.modalContent.style.transform = `translate(${deltaX + this.sumX}px, ${deltaY + this.sumY}px)`;
    };

    initialEvent = (visible) => {
        const { title } = this.props;
        let that = this;
        if (title && visible) {
            setTimeout(() => {
                window.removeEventListener('mouseup', that.removeUp, false);

                that.contain = document.getElementsByClassName(that.simpleClass)[0];
                that.header = that.contain.getElementsByClassName('ant-modal-header')[0];
                that.modalContent = that.contain.getElementsByClassName('ant-modal-content')[0];

                that.header.style.cursor = 'all-scroll';
                that.header.title = '点击左键可拖拽';
                that.header.onmousedown = (e) => {
                    that.mouseDownX = e.pageX;
                    that.mouseDownY = e.pageY;
                    document.body.onselectstart = () => false;
                    window.addEventListener('mousemove', that.handleMove, false);
                };

                window.addEventListener('mouseup', that.removeUp, false);
            }, 0);
        }
    };

    removeMove = () => {
        window.removeEventListener('mousemove', this.handleMove, false);
    };

    removeUp = () => {
        document.body.onselectstart = () => true;

        this.sumX = this.sumX + this.deltaX;
        this.sumY = this.sumY + this.deltaY;

        this.removeMove();
    };

    componentDidMount() {
        const { visible = false } = this.props;
        this.initialEvent(visible);
    }

    componentWillUnmount() {
        this.removeMove();
        window.removeEventListener('mouseup', this.removeUp, false);
    }
    render() {
        const { children, wrapClassName, ...other } = this.props;
        const wrapModalClassName = wrapClassName ? `${wrapClassName} ${this.simpleClass}` : `${this.simpleClass}`;
        return (
            <Modal
                {...other}
                wrapClassName={wrapModalClassName}
            >{children}</Modal>
        );
    }
}

export default AntDraggableModal



// WEBPACK FOOTER //
// ./src/components/AntDraggableModal.js